import React from 'react';
import { componentService } from 'js/services/component.service';

export const MobileCashier = React.lazy(() => import(/* webpackChunkName: "mobile-cashier" */ './MobileCashier'));

componentService.registerPageComponents({ 'mobile-cashier': MobileCashier });
